import dynamic from 'next/dynamic'
import { ThumbUpFilledIcon } from '~/components/icons/generated/ThumbUpFilledIcon'
import { ThumbUpIcon } from '~/components/icons/generated/ThumbUpIcon'
import { useIsLoggedIn } from '~/hooks/useIsLoggedIn'
import { useModal } from '~/hooks/useModal'

const LoginPromptModal = dynamic(
  import('~/components/modules/LoginPromptModal').then(
    (mod) => mod.LoginPromptModal
  ),
  {
    ssr: false,
  }
)

type Props = {
  isLiked: boolean
  likeCount: number
  onClick: () => void
}

type ViewProps = {
  isLiked: boolean
  likeCount: number
  onClick: () => void
}

export const LikeButtonView: React.FC<ViewProps> = ({
  isLiked,
  likeCount,
  onClick,
}) => (
  <button
    aria-label={`${likeCount}件のいいね。${
      isLiked ? 'いいねを解除する' : 'いいねする'
    }`}
    onClick={onClick}
    className="flex size-[58px] flex-col items-center justify-center gap-[3px] rounded-[50%] border border-gray-300 bg-white"
    type="button"
  >
    <span className="relative">
      {isLiked ? (
        <ThumbUpFilledIcon className="block h-6 font-bold leading-none text-yellow-400 duration-300" />
      ) : (
        <ThumbUpIcon className="block h-6 font-bold leading-none text-black-400 duration-300" />
      )}
      <ThumbUpFilledIcon
        className={`absolute left-0 top-0 block h-6 origin-center scale-0 animate-[ping] text-yellow-400 ${
          isLiked ? 'scale-[2] opacity-0 duration-300' : ''
        }`}
      />
    </span>
    <span className="text-[12px] font-bold leading-[1.2] text-black-500">
      {likeCount}
    </span>
  </button>
)

export const LikeButton: React.FC<Props> = ({
  isLiked,
  likeCount,
  onClick,
}) => {
  const [Modal, openModal, closeModal, isOpen] = useModal(200)
  const isLoggedIn = useIsLoggedIn()

  return (
    <>
      <LikeButtonView
        isLiked={isLiked}
        likeCount={likeCount}
        onClick={() => {
          if (!isLoggedIn) {
            openModal()
            return
          }
          onClick()
        }}
      />
      <Modal
        wrapperClassName={`ease-linear duration-200 transition-all ${
          isOpen ? 'opacity-100' : 'opacity-0'
        }`}
        overlayClassName="bg-black/80"
      >
        <LoginPromptModal close={closeModal} text="いいねするには">
          <ThumbUpIcon className="inline h-[60px]" />
        </LoginPromptModal>
      </Modal>
    </>
  )
}
